export const serviceCards = [
  {
    name: "adobe",
    imagePath: "adobe.svg",
    order: 4,
    width: 93,
    height: 52,
  },
  {
    name: "amazon",
    imagePath: "amazon.svg",
    order: 22,
    width: 93,
    height: 52,
  },
  {
    name: "discord",
    imagePath: "discord.svg",
    order: 27,
    width: 0,
    height: 48,
  },
  {
    name: "imgur",
    imagePath: "imgur.svg",
    order: 25,
    width: 130,
    height: 0,
  },
  {
    name: "clearviewai",
    imagePath: "clearviewai.svg",
    order: 10,
    width: 93,
    height: 52,
  },
  {
    name: "microsoft-office",
    imagePath: "microsoft-office.svg",
    order: 11,
    width: 43,
    height: 52,
  },
  {
    name: "deviantart",
    imagePath: "deviantart.svg",
    order: 7,
    width: 93,
    height: 52,
  },
  {
    name: "disqus",
    imagePath: "disqus.svg",
    order: 16,
    width: 93,
    height: 52,
  },
  {
    name: "figma",
    imagePath: "figma.svg",
    order: 2,
    width: 93,
    height: 52,
  },
  {
    name: "microsoft-teams",
    imagePath: "microsoft-teams.svg",
    order: 20,
    width: 58,
    height: 52,
  },
  {
    name: "myanimelist",
    imagePath: "myanimelist.svg",
    order: 21,
    width: 0,
    height: 52,
  },
  {
    name: "gyazo",
    imagePath: "gyazo.svg",
    order: 18,
    width: 93,
    height: 52,
  },
  {
    name: "imdb",
    imagePath: "imdb.svg",
    order: 15,
    width: 93,
    height: 52,
  },
  {
    name: "linkedin",
    imagePath: "linkedin.svg",
    order: 13,
    width: 93,
    height: 52,
  },
  {
    name: "skype",
    imagePath: "skype.svg",
    order: 17,
    width: 0,
    height: 52,
  },
  {
    name: "meta",
    imagePath: "meta.svg",
    order: 1,
    width: 93,
    height: 52,
  },
  {
    name: "stackoverflow",
    imagePath: "stackoverflow.svg",
    order: 28,
    width: 0,
    height: 35,
  },
  {
    name: "pinterest",
    imagePath: "pinterest.svg",
    order: 23,
    width: 93,
    height: 52,
  },
  {
    name: "quora",
    imagePath: "quora.svg",
    order: 14,
    width: 93,
    height: 52,
  },
  {
    name: "reddit",
    imagePath: "reddit.svg",
    order: 6,
    width: 93,
    height: 52,
  },
  {
    name: "slack",
    imagePath: "slack.svg",
    order: 8,
    width: 93,
    height: 52,
  },
  {
    name: "spotify",
    imagePath: "spotify.svg",
    order: 19,
    width: 93,
    height: 52,
  },
  {
    name: "squarespace",
    imagePath: "squarespace.svg",
    order: 9,
    width: 93,
    height: 52,
  },
  {
    name: "tumblr",
    imagePath: "tumblr.svg",
    order: 3,
    width: 93,
    height: 52,
  },
  {
    name: "twitter",
    imagePath: "twitter.svg",
    order: 5,
    width: 93,
    height: 52,
  },
  {
    name: "steam",
    imagePath: "steam.svg",
    order: 24,
    width: 0,
    height: 52,
  },
  {
    name: "wordpress",
    imagePath: "wordpress.svg",
    order: 12,
    width: 93,
    height: 52,
  },
];

export const landingpagetext = {
  Title: "AI Opt-out Guide",
  WelcomeText:
    "Choose from the options below, to begin opting-out of platforms AI powered data collection services. Your data should belong to you, so take the steps necessary to protect yourself & your data.",
  OptOutServices: "Opt out from the following AI sites and services:",
  DataQuestion: `It's your data, shouldn't you control it?`,
  RedactoWoopsieTitle: "Why should I care?",
  RedactoWoopsieText: `In the age of AI, your personal data has never been more at risk.
  
      Your private data, user-generated content, and personal information are being harvested by companies, governments, and malicious actors to train AI models.
      These can threaten the security of your digital footprint, primarily due to AI’s advanced capabilities in processing, analyzing, and interpreting your personal information. 
      
      An alarming number of sites, services, and companies have defaulted to enabling your data for these AI training models and harvesters. That means even if you did not elect to have your data used by AI, chances are it is!`,
  RedactoImagePath: "redacto-woopsie.svg",
  AIThreatsTitle: "What threats does AI pose?",
  RedactoProtectTitle: `What can I do to 
    
    protect myself from AI`,
  RedactoProtectText:
    'Many platforms & services have an opt-out page (due to regulations) where you can elect to have your data removed from AI training and harvesting. Click the "Get Started" button, and a guide will populate for the services or site listed.',
  RedactoProtectImagePath: "redacto-space.svg",
  DeleteDigitalFootprintTitle: "A way to delete your digital footprint",
  DeleteDigitalFoorprintText:
    "Cleaning up your social networks can be a hassle, Redact makes it easy to cleanup, delete and refresh your social networks in one place. Deleting your data can massively increase the protection against AI.",
  ListDeleteSocialNetworkTitle: "Deletion for social networks",
  ListDeleteSocialNetworkDescription:
    "Continuing to expand our service reach, supporting deletion for social media applications.",
  ListDeleteVariousContentTitle: "Deleting various content",
  ListDeleteVariousContentDescription:
    "Delete content like images, post, comments, follows and likes.",
  ListScheduledDeletionTitle: "Scheduled deletion",
  ListScheduledDeletionDescription:
    "Specify what content to delete and set a recurring schedule for it for less hassle.",
  FooterTitle: "Download Redact today.",
  FooterDescription:
    "We are frequently updating support to other social network services. You can receive direct updates from us in our Discord Channel.",
  Lang: "EN",
};

export const threatCards = [
  {
    Title: "Reduced Privacy",
    Description:
      "AI-powered systems may compromise your privacy by accessing, collecting, and storing your personal data without your explicit consent. This  includes location data, communication patterns, and even biometric data, images & videos. You have been exposed largest data harvesting event since the begging of the  internet.",
    ImagePath: "redact-reduce-privacy-icon.svg",
  },
  {
    Title: "Predictive modeling",
    Description:
      "AI is extremely adept at predicting your behavior, preferences, and even future actions based on historical data. While this is typically used for targeted advertising, it has now raised concerns about manipulation and exploitation by malicious actors. This allows tools to scrape highly detailed  data from anyone they can.",
    ImagePath: "redact-predictive-modeling-icon.svg",
  },
  {
    Title: "Targeted attacks",
    Description:
      "Recently, new advanced attacks on users have been leveraging AI’s abilities to mimic users. A new attack type called ‘Vishing’, where an AI model collects data on a users voice, synthesizes a speech bot to sound like that individual, and uses that to gain access to secure elements (banking, 2fa recovery, asking for money from relatives etc)",
    ImagePath: "redact-targeted-attacks-icon.svg",
  },
  {
    Title: "Personal content",
    Description:
      "Creatives spend their blood, sweat, and tears creating and sharing their work online. Many platforms where users post have started using their content to train their AI models, which the AI can then use to create content in the same style as the artist. This can lead to a loss of control in the artist or creatives ability to protect their work.",
    ImagePath: "redact-personal-content-icon.svg",
  },
];

export const optoutpagetext = {
  Title: "Full AI Opt out guide list",
  OptOutServices: "Opt out from the following AI sites and services:",
  FooterTitle: "Powered by Redact",
  FooterDescription:
    "Redact empowers individuals to privately and securely automate the removal of their data from nearly every major platform. Download Redact today and take control of your digital footprint.",
  Lang: "EN",
};
